import { render, staticRenderFns } from "./allDetail.vue?vue&type=template&id=43f62368&scoped=true"
import script from "./allDetail.vue?vue&type=script&lang=js"
export * from "./allDetail.vue?vue&type=script&lang=js"
import style0 from "./allDetail.vue?vue&type=style&index=0&id=43f62368&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f62368",
  null
  
)

export default component.exports